const images = require.context("./img", true, /\.(svg|png|ico)$/);
images.keys().forEach(images);
